import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {Router} from '@angular/router';
import * as globals from '../../settings';
import {LotteriesService} from '../../lotteries.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../_services/user.service';
import {Subscription} from 'rxjs';
import {CurrencyService} from '../../_services/currency.service';

@Component({
  selector: 'app-total-wins',
  templateUrl: './total-wins.component.html',
  styleUrls: ['./total-wins.component.scss']
})
export class TotalWinsComponent implements OnInit, OnDestroy {
  modalSize: any;
  user: any;
  languageChange: any;
  showLang: any;
  showLangRoute: any;
  jackpotSum: any;
    changedCurrency: Subscription;
    currency: any;
  constructor(private router: Router, public subscriptionsService: SubscriptionsService,
              public lotteryService: LotteriesService, private translate: TranslateService,
              public currencyService: CurrencyService, public userService: UserService) {
      this.currency = this.currencyService.currency;
      if (!this.currency) {
          this.currency = JSON.parse(localStorage.getItem('currency'));
      }
      this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
          if (currency) {
              this.currency = currency;
          }
      });
  }

  ngOnInit() {
      const user = localStorage.getItem('playerDetails');
      if (user) {
          this.user = JSON.parse(user);
      }


      this.languageChange = this.subscriptionsService.getLanguage().subscribe( lang => {
          this.showLang =  lang;
          this.showLangRoute =  '/' + lang;
      });

      this.lotteryService.postData(globals.appDomain + '/draws/incomingDrawsJackpotSum/drawsIncomingDrawsJackpotSum.json', '')
          .subscribe(
              result => {
                  this.jackpotSum = result[0];
              }
          );

      this.showLang = this.translate.currentLang;
  }

  openRegister() {
    localStorage.setItem('isOpenRegister', 'true');
    setTimeout(() => {
      localStorage.removeItem('isOpenRegister');
    }, 50);
    this.subscriptionsService.emitRegister(true);
    this.modalSize = 'modal-md';
  }

    openAllLotteries() {
        this.router.navigate(['/' + this.showLang, 'lotteries']);
    }

    ngOnDestroy() {
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
    }

}
